"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformModelStatus = exports.SdPlatformModelTrustlevel = void 0;
/** Level of trust into a model. */
var SdPlatformModelTrustlevel;
(function (SdPlatformModelTrustlevel) {
    SdPlatformModelTrustlevel["UNDEFINED"] = "";
    /** No trust into the model. */
    SdPlatformModelTrustlevel["NONE"] = "none";
    /** Full trust into the model. */
    SdPlatformModelTrustlevel["FULL"] = "full";
})(SdPlatformModelTrustlevel = exports.SdPlatformModelTrustlevel || (exports.SdPlatformModelTrustlevel = {}));
/**
 * Platform Backend model status.
 */
var SdPlatformModelStatus;
(function (SdPlatformModelStatus) {
    /** before model upload */
    SdPlatformModelStatus["Start"] = "start";
    /** model uploaded successfully */
    SdPlatformModelStatus["Waiting"] = "waiting";
    /** model has been confirmed, settings not stored yet */
    SdPlatformModelStatus["Confirmed"] = "confirmed";
    /** model has been confirmed, settings already stored */
    SdPlatformModelStatus["Done"] = "done";
    /** model checking has been suspended, ShapeDiver admin input required */
    SdPlatformModelStatus["Pending"] = "pending";
    /** model has been denied */
    SdPlatformModelStatus["Denied"] = "denied";
    /** upload of model failed */
    SdPlatformModelStatus["ErrorUpload"] = "error_upload";
    SdPlatformModelStatus["Error"] = "error";
})(SdPlatformModelStatus = exports.SdPlatformModelStatus || (exports.SdPlatformModelStatus = {}));
/**
 * Reasons for a model getting denied.
 */
var SdPlatformModelDenyReason;
(function (SdPlatformModelDenyReason) {
    SdPlatformModelDenyReason["Unknown"] = "unknown";
    /** unsupported plug-in */
    SdPlatformModelDenyReason["Plugin"] = "plugin";
    /** denied script */
    SdPlatformModelDenyReason["Script"] = "script";
    /** timeout in phase "computation" of model checking (solver took more than max_comp_time but less than 2x max_comp_time) */
    SdPlatformModelDenyReason["Timeout"] = "timeout";
    /** model does not have outputs */
    SdPlatformModelDenyReason["NoOutputs"] = "no_outputs";
    /** size of outputs exceeds limit */
    SdPlatformModelDenyReason["Size"] = "size";
    /** technical limit of outputs */
    SdPlatformModelDenyReason["OutputLimits"] = "output_limits";
    /** model does not output geometry for default parameter values */
    SdPlatformModelDenyReason["NoDefaultGeometry"] = "no_default_geometry";
    /** timeout in phase "computation" of model checking (solver took more than 2x max_comp_time) */
    SdPlatformModelDenyReason["TimeoutSmall"] = "timeout_small";
    /** catchall worker timeout during model checking */
    SdPlatformModelDenyReason["ComputationFailed"] = "computation_failed";
    /** workers could not process check request (typically due to workload) */
    SdPlatformModelDenyReason["NotProcessed"] = "not_processed";
    /** unsupported component */
    SdPlatformModelDenyReason["Component"] = "component";
    /** denied encrypted cluster */
    SdPlatformModelDenyReason["EncryptedCluster"] = "encrypted_cluster";
    /** usage of scripts not allowed */
    SdPlatformModelDenyReason["ScriptsNotAllowed"] = "scripts_not_allowed";
    /** script check pending */
    SdPlatformModelDenyReason["ScriptsPending"] = "scripts_pending";
    /** timeout in phase "analysis" of model checking */
    SdPlatformModelDenyReason["AnalysisTimeout"] = "analysis_timeout";
    /** timeout in phase "loading" of model checking */
    SdPlatformModelDenyReason["LoadingTimeout"] = "loading_timeout";
    /** timeout in phase "preparation" of model checking */
    SdPlatformModelDenyReason["PreparationTimeout"] = "preparation_timeout";
    /** timeout in phase "collect results" of model checking (solver and collection took more than max_charge_time but less than 2x max_charge_time) */
    SdPlatformModelDenyReason["CollectTimeout"] = "collect_timeout";
    /** timeout in phase "collect results" of model checking (solver and collection took more than 2x max_charge_time) */
    SdPlatformModelDenyReason["CollectTimeoutSmall"] = "collect_timeout_small";
    /** the model requires at least Rhino 8 */
    SdPlatformModelDenyReason["RequiresRhino8"] = "requires_rhino_8";
    /** the Grasshopper version of the model is unknown */
    SdPlatformModelDenyReason["UnknownGrasshopperVersion"] = "unknown_grasshopper_version";
    /** a general technical limit has been reached when checking the model */
    SdPlatformModelDenyReason["TechnicalLimit"] = "technical_limit";
})(SdPlatformModelDenyReason || (SdPlatformModelDenyReason = {}));
//# sourceMappingURL=SdPlatformResponseModel.js.map